import React, { Fragment } from 'react';
import '../loggedOut.css';

const TacticalMinds = () => {
    return (
        <Fragment>
            <div className="logged-out">
                <section className="service-hero scene scene--hero page-hero">
                    <div className="container">
                        <div className="hero-grid">
                            <div className="hero-copy">
                                <h1 className="display-5 mb-4">Tactical Minds: Tabletop & Trading Card Games</h1>
                                <p className="lead">
                                    A mentor-supported program using tabletop, board, and trading card games to build social skills, confidence, and strategic thinking in a safe, inclusive environment. Engagement is flexible and participant-led, with plenty of different cooperative and competitive games to choose from. No prior experience is required, though challenges are available for those who want them.
                                </p>
                            </div>
                            <div className="hero-media">
                                <div className="image-shell image-shell--hero">
                                    <img
                                        src="/marketing_images/tactical_minds/1_top_pic.png"
                                        alt="Tabletop games program"
                                        className="img-fluid"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="service-benefits scene scene--paper story-band">
                    <div className="container">
                        <div className="story-card">
                            <p className="mb-5 text-center">
                                Tabletop and trading card games help participants practise problem-solving, focus, turn-taking, emotional regulation, and teamwork. No screen time is needed for this program, as everything is tactile and hands on.
                            </p>

                            <div className="tile-grid">
                                {benefits.map((benefit) => (
                                    <div className="tile-card" key={benefit.title}>
                                        <div className="image-shell image-shell--card">
                                            <img
                                                src={benefit.image}
                                                alt={benefit.title}
                                                className="img-fluid"
                                            />
                                        </div>
                                        <p className="mt-3 mb-0">{benefit.title}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>

                <section className="service-details scene scene--soft py-6">
                    <div className="container text-center">
                        <p>
                            Guided collaborative play fosters communication, confidence, and social connection, all within a structured, predictable, and supportive setting that caters to individual needs and learning styles.
                        </p>
                        <p>
                            This program is well suited to individuals who enjoy games, creativity, and structured activities, and who would like to build social skills and self-confidence while having fun.
                        </p>

                        <div className="tile-grid mt-4">
                            {[
                                { title: "Tabletop Games", image: "/marketing_images/tactical_minds/table_top_game.jpg" },
                                { title: "Board Games", image: "/marketing_images/tactical_minds/board_game.jpg" },
                                { title: "Trading Card Games", image: "/marketing_images/tactical_minds/trading_card_game.jpg" },
                            ].map((activity) => (
                                <div className="tile-card" key={activity.title}>
                                    <div className="image-shell image-shell--card">
                                        <img
                                            src={activity.image}
                                            alt={activity.title}
                                            className="img-fluid"
                                        />
                                    </div>
                                    <p className="mt-3 mb-0">{activity.title}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </div>
        </Fragment>
    );

}

export default TacticalMinds;

const benefits = [
    { title: "Problem-solving", image: "/marketing_images/tactical_minds/problem_solving.jpg" },
    { title: "Focus", image: "/marketing_images/tactical_minds/focus.jpg" },
    { title: "Turn-taking", image: "/marketing_images/tactical_minds/turn_taking.jpg" },
    { title: "Emotional regulation", image: "/marketing_images/tactical_minds/emotional_regulation.jpg" },
    { title: "Teamwork", image: "/marketing_images/tactical_minds/team_work.jpg" },
];
